export const ACCEPT_GA_TRACKING = 'accept-ga-tracking'
